import { Section } from './Section';
import './SolutionSection.css';

const capabilities = [
  {
    architectureLabel: 'Knowledge Graph',
    title: 'Understand the enterprise',
    description:
      'Connect information across raw materials, inventory, customers, orders, production, logistics, finance, and other parts of the business to understand how they affect one another.',
  },
  {
    architectureLabel: 'Event Stream',
    title: 'See what is changing',
    description:
      'Continuously bring important changes and emerging situations into view, so teams can respond before they become larger operational problems.',
  },
  {
    architectureLabel: 'Policy Engine',
    title: 'Work within the rules',
    description:
      'Take business commitments, quality requirements, customer expectations, regulatory obligations, and internal approvals into account when evaluating possible actions.',
  },
  {
    architectureLabel: 'Digital Twin',
    title: 'Explore what could happen',
    description:
      'Compare different courses of action and understand their likely effects on cost, availability, fulfillment, capacity, risk, and business outcomes before acting.',
  },
  {
    architectureLabel: 'Agent Society',
    title: 'Bring perspectives together',
    description:
      'Bring together the perspectives of sales, operations, logistics, finance, compliance, and other functions to arrive at a coordinated enterprise decision.',
  },
];

function ArchitectureFlow() {
  return (
    <div className="architecture-flow" aria-label="Existing ERP systems flow through an enterprise intelligence layer to coordinated enterprise decisions">
      <div className="architecture-flow__stage architecture-flow__stage--source">Existing ERP systems</div>
      <span className="architecture-flow__connector" aria-hidden="true" />
      <div className="architecture-flow__stage architecture-flow__stage--layer">Enterprise intelligence layer</div>
      <span className="architecture-flow__connector" aria-hidden="true" />
      <div className="architecture-flow__stage architecture-flow__stage--outcome">
        Coordinated enterprise decisions
      </div>
    </div>
  );
}

export function SolutionSection() {
  return (
    <Section id="solution" tone="surface" className="solution-section">
      <div className="solution-section__intro">
        <h2>One connected view of the enterprise</h2>
        <div className="solution-section__copy">
          <p>
            The platform brings together the information, people, processes, and changing
            circumstances that shape everyday business decisions.
          </p>
          <p>
            Instead of asking teams to piece together answers across multiple systems and
            departments, it creates a shared view of what is happening across the enterprise and
            helps people understand the choices available to them.
          </p>
        </div>
      </div>
      <ArchitectureFlow />
      <div className="solution-section__capability-layer">
        <ol className="solution-section__capabilities">
          {capabilities.map(({ architectureLabel, title, description }) => (
            <li key={architectureLabel}>
              <p className="solution-section__architecture-label">{architectureLabel}</p>
              <h3>{title}</h3>
              <p>{description}</p>
            </li>
          ))}
        </ol>
      </div>
      <p className="solution-section__conclusion">
        Together, these capabilities help the enterprise move from fragmented information and
        experience-driven decisions toward a continuously informed and coordinated way of working.
      </p>
    </Section>
  );
}
